/** 페이드 길이 — 겹쳐 바뀌는 동안 두 그림이 함께 보이므로 너무 짧으면 깜박임처럼 보인다. */
const FADE_MS = 500;
/** 움직이는 효과의 길이 — 화면 한 폭을 지나가므로 눈이 따라갈 만큼. 사이니지에서 느린 전환은 재생 시간을 갉아먹는다. */
const MOVE_MS = 700;
/** 뒤집기 한쪽(접기·펼치기) 길이. */
const FLIP_HALF_MS = 350;
/** 대각선 타일 — 쓸고 지나가는 시간과 조각 하나가 사라지는 시간. 합이 0.8초 남짓. */
const TILE_SWEEP_MS = 420;
const TILE_MS = 360;
/**
 * 부드럽게 출발해 길게 멈춘다 — 화면 한 폭을 움직이는 효과의 곡선(머티리얼 표준 곡선).
 *
 * 예전 곡선(0.22, 0.61, 0.36, 1)은 출발 기울기가 2.8 이라 첫 150ms 에 70% 를 가 버리고 나머지를 기어갔다 —
 * 저사양 기기에서는 첫 프레임이 툭 튀고 끝이 늘어져 보였다.
 */
const STANDARD = 'cubic-bezier(0.4, 0, 0.2, 1)';
/** 겹쳐 나타나기 — 양끝을 살짝 누그러뜨린 거의 고른 속도. */
const DISSOLVE = 'cubic-bezier(0.45, 0, 0.55, 1)';
/** 점점 빠르게 — 조각이 제자리에서 천천히 떨어져 나가 빨리 사라진다. */
const EASE_IN = 'cubic-bezier(0.4, 0, 1, 1)';
/** 접기는 점점 빠르게, 펼치기는 빠르게 시작해 천천히 — 화면이 옆으로 선(검은) 순간을 짧게 한다. */
const FOLD = 'cubic-bezier(0.32, 0, 0.67, 0)';
const UNFOLD = 'cubic-bezier(0.33, 1, 0.68, 1)';
/** 뒤집기의 원근 — 무대 폭의 두 배 떨어진 곳에서 본다(가까운 가장자리가 30% 남짓 커진다). */
const FLIP_VIEW = 'perspective(200sw)';
/** 제자리에 보이는 층. */
export const SHOWN = { opacity: '1', transform: '' };
/** 감춘 층 — 투명하고 제자리. */
export const HIDDEN = { opacity: '0', transform: '' };
const FADE = {
    enterFrom: { opacity: '0', transform: '' },
    enterTo: SHOWN,
    enter: { ms: FADE_MS, delayMs: 0, easing: DISSOLVE },
    // 이전 화면은 그대로 — 다음 화면이 그 위에 겹쳐 나타난다.
    exitFrom: SHOWN,
    exitTo: SHOWN,
    exit: { ms: FADE_MS, delayMs: 0, easing: DISSOLVE },
};
/** 함께 움직이는 두 층 — 한 판처럼 이어 붙어 미끄러진다. */
function push(axis) {
    const at = (percent) => axis === 'x' ? `translate3d(${percent}%, 0, 0)` : `translate3d(0, ${percent}%, 0)`;
    const motion = { ms: MOVE_MS, delayMs: 0, easing: STANDARD };
    return {
        enterFrom: { opacity: '1', transform: at(100) },
        enterTo: SHOWN,
        enter: motion,
        exitFrom: SHOWN,
        exitTo: { opacity: '1', transform: at(-100) },
        exit: motion,
    };
}
const PLANS = {
    fade: FADE,
    // 밀기 — 새 화면이 오른쪽에서 들어오며 이전 화면을 왼쪽으로 밀어낸다.
    slide: push('x'),
    // 위로 밀기 — 아래에서 올라와 이전 화면을 위로 밀어낸다. 세로로 세운 화면에 어울린다.
    'slide-up': push('y'),
    // 확대 — 이전 화면이 앞으로 다가오고, 그 위에 새 화면이 살짝 작은 데서 커지며 겹쳐 나타난다(앞으로 나아가는 느낌).
    zoom: {
        enterFrom: { opacity: '0', transform: 'scale(0.95)' },
        enterTo: SHOWN,
        /*
         * 크기가 투명도보다 먼저 다 자란다 — 함께 자라면 반쯤 비친 새 화면의 가장자리가 이전 화면 위에 사각 테두리로
         * 보였다(투명도를 먼저 채우면 더 또렷했다). 먼저 자라면 그 가장자리는 새 화면이 아직 희미할 때만 안쪽에 있고,
         * 또렷해질 즈음엔 화면 끝에 닿아 있다.
         */
        enter: { ms: Math.round(MOVE_MS * 0.7), delayMs: 0, easing: STANDARD, opacityMs: MOVE_MS },
        exitFrom: SHOWN,
        exitTo: { opacity: '1', transform: 'scale(1.12)' },
        exit: { ms: MOVE_MS, delayMs: 0, easing: STANDARD },
    },
    /*
     * 덮기 — 새 화면이 그림자를 드리운 카드처럼 오른쪽에서 미끄러져 와 덮고, 이전 화면은 조금 왼쪽으로 물러나며
     * 어두워진다. 이전 화면은 줄이지 않는다 — 줄이면 사방에 검은 테두리가 드러났다. 물러나는 폭(30%)이 들어오는
     * 폭(100%)보다 작아 두 층 사이가 벌어지지 않는다.
     */
    cover: {
        enterFrom: { opacity: '1', transform: 'translate3d(100%, 0, 0)', shadow: '-1.5sw 0 4sw rgba(0, 0, 0, 0.5)' },
        enterTo: { opacity: '1', transform: '', shadow: '-1.5sw 0 4sw rgba(0, 0, 0, 0.5)' },
        enter: { ms: MOVE_MS, delayMs: 0, easing: STANDARD },
        exitFrom: SHOWN,
        exitTo: { opacity: '0.45', transform: 'translate3d(-30%, 0, 0)' },
        exit: { ms: MOVE_MS, delayMs: 0, easing: STANDARD },
    },
    /*
     * 뒤집기 — 카드를 뒤집듯 세로 축으로 돈다. 이전 화면이 옆으로 설 때까지 돌고(90°), 이어서 다음 화면이 반대쪽에서
     * 돌아 나온다. 한 층씩 90° 까지만 돌아 뒷면(backface)을 다룰 일이 없다.
     */
    flip: {
        enterFrom: { opacity: '1', transform: `${FLIP_VIEW} rotateY(-90deg)` },
        enterTo: { opacity: '1', transform: `${FLIP_VIEW} rotateY(0deg)` },
        enter: { ms: FLIP_HALF_MS, delayMs: FLIP_HALF_MS, easing: UNFOLD },
        exitFrom: { opacity: '1', transform: `${FLIP_VIEW} rotateY(0deg)` },
        exitTo: { opacity: '1', transform: `${FLIP_VIEW} rotateY(90deg)` },
        exit: { ms: FLIP_HALF_MS, delayMs: 0, easing: FOLD },
    },
    /*
     * 대각선 타일 — 이전 화면이 바둑판 조각으로 나뉘어 왼쪽 위부터 대각선을 따라 차례로 작아지며 사라지고, 그 밑에서
     * 다음 화면이 드러난다. 다음 화면은 처음부터 불투명하게 깔려 있어(조각 사본이 그것을 가린다) 영상·템플릿도
     * 그대로 돌고, 조각 사이로 검은 무대가 비치지 않는다.
     */
    tiles: {
        enterFrom: SHOWN,
        enterTo: SHOWN,
        enter: { ms: 0, delayMs: 0, easing: 'linear' },
        // 이전 층은 사본 밑에서 곧바로 감춘다 — 조각이 빠져나간 자리에 다음 화면만 보이게.
        exitFrom: SHOWN,
        exitTo: HIDDEN,
        exit: { ms: 0, delayMs: 0, easing: 'linear' },
        tiles: {
            longSide: 8,
            sweepMs: TILE_SWEEP_MS,
            motion: { ms: TILE_MS, delayMs: 0, easing: EASE_IN },
            to: { opacity: '0', transform: 'scale(0.2)' },
        },
    },
};
/**
 * 이 전환을 어떻게 그리는가. `none` 이면 null — 곧바로 바꾼다.
 *
 * **모르는 값은 페이드다.** 서버가 이 화면보다 새 효과를 먼저 알 수 있다(에이전트는 따로 올라간다).
 */
export function transitionPlan(kind) {
    if (kind === 'none')
        return null;
    return PLANS[kind ?? ''] ?? FADE;
}
/** 한 층이 다 움직이는 때 — 지연 뒤 투명도와 변형 가운데 늦게 끝나는 쪽. */
export function motionEndMs(motion) {
    return motion.delayMs + Math.max(motion.ms, motion.opacityMs ?? motion.ms);
}
/** 두 층(과 조각)이 다 움직이는 데 걸리는 시간 — 나간 층을 감추고 들어온 층을 제자리로 돌려놓을 때를 정한다. */
export function transitionTotalMs(plan) {
    const tiles = plan.tiles ? plan.tiles.sweepMs + motionEndMs(plan.tiles.motion) : 0;
    return Math.max(motionEndMs(plan.enter), motionEndMs(plan.exit), tiles);
}
/**
 * 무대를 조각으로 나눈다 — 왼쪽 위 조각이 먼저, 오른쪽 아래 조각이 마지막에 출발한다(같은 대각선은 함께).
 *
 * 경계는 반올림한 정수 px 로 이어 붙인다 — 조각마다 따로 반올림하면 사이에 1px 틈이나 겹침이 생겨 처음 한 프레임에
 * 바둑판 줄이 비친다.
 */
export function tileGrid(width, height, plan) {
    const landscape = width >= height;
    const long = Math.max(1, plan.longSide);
    const short = Math.max(1, Math.round((long * Math.min(width, height)) / Math.max(width, height, 1)));
    const columns = landscape ? long : short;
    const rows = landscape ? short : long;
    const edge = (index, count, size) => Math.round((index * size) / count);
    const last = columns + rows - 2;
    const tiles = [];
    for (let row = 0; row < rows; row++) {
        for (let column = 0; column < columns; column++) {
            const x = edge(column, columns, width);
            const y = edge(row, rows, height);
            tiles.push({
                x,
                y,
                width: edge(column + 1, columns, width) - x,
                height: edge(row + 1, rows, height) - y,
                delayMs: last > 0 ? Math.round((plan.sweepMs * (column + row)) / last) : 0,
            });
        }
    }
    return tiles;
}
/** CSS `transition` 값 — 두 속성을 같은 곡선으로(투명도만 따로 짧게 끝낼 수 있다). */
export function cssTransition(motion) {
    const timing = (ms) => `${ms}ms ${motion.easing} ${motion.delayMs}ms`;
    return `opacity ${timing(motion.opacityMs ?? motion.ms)}, transform ${timing(motion.ms)}`;
}
/**
 * 한 모습을 층에 줄 CSS 값으로 — `sw`(무대 폭의 1%)를 px 로 바꾼다.
 *
 * 그리는 쪽(플레이어·미리보기)은 이 값을 `style.opacity`·`style.transform`·`style.boxShadow` 에 그대로 넣는다.
 * 그림자가 없는 모습도 빈 문자열을 돌려줘 지난 전환의 그림자를 지운다.
 */
export function lookStyle(look, stageWidth) {
    // 아직 그려지지 않은 무대(폭 0)에서도 원근이 0 이 되지 않게 — 0 은 원근이 아니라 납작한 그림이다.
    const width = stageWidth > 0 ? stageWidth : 1920;
    const px = (value) => value.replace(/(-?\d*\.?\d+)sw\b/g, (_, n) => `${Math.round((Number(n) * width) / 100)}px`);
    return { opacity: look.opacity, transform: px(look.transform), boxShadow: px(look.shadow ?? '') };
}
//# sourceMappingURL=transitions.js.map